export const download = {
  download: {
    shape:
      '<path fill="#000" fill-opacity=".86" d="M6.625 19c-.467 0-.854-.154-1.162-.462-.309-.309-.463-.696-.463-1.163V15h1v2.375c0 .167.063.312.188.437s.27.188.437.188h10.75a.597.597 0 0 0 .437-.188.597.597 0 0 0 .188-.437V15h1v2.375c0 .467-.154.854-.462 1.163-.309.308-.696.462-1.163.462H6.625ZM12 15.225 8.45 11.7l.725-.725L11.5 13.3V4.65h1v8.65l2.325-2.325.725.725L12 15.225Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
